import React from 'react';
import { SiteContainer } from 'core/layout';
import { Close } from 'core/icons';
import { Button } from 'elements';
import tulkojumi from 'utils/tulkojumi';
import isDescendant from 'utils/isDescendant';
import {
  StyledPopup,
  Container,
  TopBar,
  Content,
} from './styled';

class Popup extends React.PureComponent {
  componentDidMount() {
    window.addEventListener('click', this._onWindowClick);
    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll');

    // NOTE: iOS input lauku :focus bug-fix iekš fixed position modal.
    // Šobrīd Popup position 'absolute', tāpēc nepieciešams scrollTo 0.
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this._onWindowClick);
    document.body.classList.remove('no-scroll');
    document.documentElement.classList.remove('no-scroll');
  }

  _onWindowClick = (event) => {
    const insidePopup = isDescendant(this._popupContainer, event.target);
    const isFeedbackButton = event && event.target.getAttribute('data-query-id') === 'js-feedback-button';
    if (!insidePopup && !isFeedbackButton) {
      const {
        onClose,
      } = this.props;
      onClose && onClose();
    }
  }

  render() {
    const {
      teksti,
      onClose,
      children,
    } = this.props;

    return (
      <StyledPopup>

        <SiteContainer>
          <Container innerRef={c => this._popupContainer = c}>
            <TopBar>
              <Button
                type='text'
                accent='secondary'
                icon={Close}
                iconSize='large'
                label={tulkojumi(teksti, 'aizvert')}
                a11yLabel={tulkojumi(teksti, 'aizvert')}
                onClick={() => {
                  onClose && onClose();
                }}
              />
            </TopBar>
            <Content>
              {children}
            </Content>
          </Container>
        </SiteContainer>

      </StyledPopup>
    );
  }
}

export default Popup;



// WEBPACK FOOTER //
// ./src/modules/Popup/Popup.jsx